import type { AnsweredQuestionnaire } from "@9amhealth/openapi";
import type { OwnedDbOperationResult } from "@9amhealth/shared";
import { ensureOwnership, getDb, runForOwner } from "./DbService";
import { JourneyMetaService } from "./JourneyMetaService";

const STORE_KEY = "all";
const META_KEY = "answered";

export const DbAnsweredQuestionnairesService = {
  async get(): Promise<AnsweredQuestionnaire[] | undefined> {
    await ensureOwnership();
    const db = getDb();
    const row = await db.answeredQuestionnaires.get(STORE_KEY);
    return row?.data;
  },

  async putForOwner(
    expectedOwnerId: string | null,
    data: AnsweredQuestionnaire[],
    lastFetchAt: number
  ): Promise<OwnedDbOperationResult<void>> {
    return runForOwner(expectedOwnerId, (db) =>
      db.transaction("rw", db.answeredQuestionnaires, db.meta, async () => {
        await db.answeredQuestionnaires.put({ key: STORE_KEY, data });
        await db.meta.put({ key: META_KEY, lastFetchAt });
      })
    );
  },

  async invalidate(): Promise<void> {
    await ensureOwnership();
    const db = getDb();
    await db.answeredQuestionnaires.delete(STORE_KEY);
    await JourneyMetaService.invalidate(META_KEY);
  }
};
